import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_CHEVRON_RIGHT } from '@bwoty-web/ui-kit/icons';
import './nugget.scss';

const Nugget = ({ heading, children, className = null, onClick }) => {
  return (
    <div className={cx('gw-hotel-nugget', className)}>
      <button
        type="button"
        className="gw-hotel-nugget__heading"
        onClick={onClick}
      >
        <h3>{heading}</h3>
        <Icon path={UI_CHEVRON_RIGHT} size="xs" />
      </button>
      <div className="gw-hotel-nugget__content">{children}</div>
    </div>
  );
};

Nugget.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default Nugget;
